module.exports = __webpack_public_path__ + "static/media/kodiranePlombe3.aaa42cc3.JPG";